import * as firebase from 'firebase/app';
import 'firebase/auth';

// eslint-disable-next-line import/prefer-default-export
export const authTokenInterceptor = async (config) => {
  const user = firebase.auth().currentUser;
  const token = user ? (await user.getIdToken()) : null;

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`; // eslint-disable-line
  }

  return config;
};
